import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navigation",
  style: {"overflow":"hidden"}
}
const _hoisted_2 = { class: "navigation-wrapper" }
const _hoisted_3 = { class: "navigation-split-left nav" }
const _hoisted_4 = { class: "navigation-split-right nav" }
const _hoisted_5 = { class: "justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("nav", _hoisted_3, [
          _createElementVNode("ul", null, [
            _createVNode(_component_router_link, {
              class: "text-dark",
              to: "/"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("img", {
                  src: "/public/images/logo-wide.svg",
                  class: "logo"
                }, null, -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Coop", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/market" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Market", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/front/aide" }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("Aide", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/faq" }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("FAQ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/tutoriels" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Tutoriels", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/auth/sign-up-collectivite" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Créer une collectivité", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/auth/sign-up" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Inscription", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: "/auth/sign-in" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Connexion ", -1),
                  _createElementVNode("img", {
                    src: "/public/icons/icon-go.svg",
                    class: "nav-icon"
                  }, null, -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "navigation-main" }, "   ", -1))
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("footer", null, [
      _createElementVNode("p", null, "© 2024 Coop Finance. All rights reserved.")
    ], -1))
  ]))
}